/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse, RemovePayload } from "models";
import { BrandPayload } from "models/brand";
import { PayloadAction } from "@reduxjs/toolkit";
import { PaymentForm } from "models/payment";
import { toast } from "react-toastify";
import subscriptionApi from "api/subscriptionApi";
import { subscriptionAction } from "./subscriptionSlice";
import { StoreList } from "models/subscription";

function* getSubscriptionList(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      subscriptionApi.getSubscriptionList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(subscriptionAction.getSubscriptionSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(subscriptionAction.getSubscriptionFailed(errorData));
  }
}

function* getSubscriptionById(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      subscriptionApi.getSubscriptionById,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(subscriptionAction.getSubscriptionByIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(subscriptionAction.getSubscriptionByIdFailed(errorData));
  }
}

function* getAllSubscriptions() {
  try {
    const response: ApiResponse = yield call(
      subscriptionApi.getAllSubscription
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(subscriptionAction.getAllSubscriptionSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(subscriptionAction.getAllSubscriptionFailed(errorData));
  }
}

function* updateSubscription(action: PayloadAction<PaymentForm>) {
  try {
    const response: ApiResponse = yield call(
      subscriptionApi.updateSubscription,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(subscriptionAction.updateSubscriptionSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(subscriptionAction.updateSubscriptionFailed(errorData));
  }
}

function* deleteSubscription(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      subscriptionApi.deleteSubscription,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(subscriptionAction.deleteSubscriptionSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(subscriptionAction.deleteSubscriptionFailed(errorData));
  }
}

function* getStoreListData(action: PayloadAction<StoreList>) {
  try {
    const response: ApiResponse = yield call(
      subscriptionApi.storeListApi,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(subscriptionAction.getStoreListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(subscriptionAction.getStoreListFailed(errorData));
  }
}

export default function* subscriptionSaga() {
  yield takeLatest(subscriptionAction.getSubscription, getSubscriptionList);
  yield takeLatest(subscriptionAction.getSubscriptionById, getSubscriptionById);
  yield takeLatest(subscriptionAction.getAllSubscription, getAllSubscriptions);
  yield takeLatest(subscriptionAction.deleteSubscription, deleteSubscription);
  yield takeLatest(subscriptionAction.updateSubscription, updateSubscription);
  yield takeLatest(subscriptionAction.getStoreList, getStoreListData);
}
